import { render, staticRenderFns } from "./inventoryUDIManage.vue?vue&type=template&id=1e9649cc&"
import script from "./inventoryUDIManage.vue?vue&type=script&lang=js&"
export * from "./inventoryUDIManage.vue?vue&type=script&lang=js&"
import style0 from "./inventoryUDIManage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports